import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { color } from '../../styles';

interface Props {
  children: React.ReactNode;
}

const ContentContainer = css`
  width: 480px;
  margin-bottom: 16px;
`;

const ContentTitle = css`
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3em;
  border-bottom: 3px solid ${color.dark_gray};
`;

const InheritedWidth = css`
  width: inherit;
`;

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

export const CareRecordUrineSection = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={[ContentContainer]}>
      <div css={[AlignCenter, ContentTitle]}>{t('urine', '排尿')}</div>
      <div css={InheritedWidth}>{children}</div>
    </div>
  );
};
